import { TranslationKey } from 'locales/fr';

export const computeLoginErrorMessage = (code: string): TranslationKey => {
    switch (code) {
        case 'login_failed':
            return 'login_page.login_failed';
        case 'customer_has_not_access_to_this_channel':
            return 'login_page.customer_has_not_access_to_this_channel';
        case 'customer_is_outside_his_access_dates':
            return 'login_page.customer_is_outside_his_access_dates';
        default:
            return 'login_page.uncatched_error';
    }
};
